import { Reveal } from "./Reveal";

const insurers = [
    "LIC of India", "HDFC Ergo", "ICICI Lombard", "Star Health",
    "Tata AIG", "New India Assurance", "Bajaj Allianz", "SBI General",
    "Niva Bupa", "Care Health", "Cholamandalam MS", "Reliance General",
];

export const Insurers = () => (
    <section id="insurers" data-testid="insurers-section" className="border-y border-line bg-white/40">
        <div className="mx-auto max-w-7xl px-6 py-28 md:px-12">
            <Reveal className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
                <h2 className="max-w-lg font-serif text-4xl font-medium leading-none tracking-tight md:text-5xl">
                    One door. <span className="italic text-clay">Forty-plus insurers.</span>
                </h2>
                <p className="max-w-sm text-base leading-relaxed text-moss">
                    We place policies with every major IRDAI-registered life and general insurer in India — so you never have to shop around.
                </p>
            </Reveal>
            <div className="grid grid-cols-2 gap-px border border-line bg-line md:grid-cols-4">
                {insurers.map((name, i) => (
                    <Reveal key={name} delay={(i % 4) * 0.05} className="bg-bone">
                        <div
                            data-testid={`insurer-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="flex h-24 items-center justify-center px-4 transition-colors duration-300 hover:bg-white"
                        >
                            <span className="text-center font-serif text-lg font-medium text-moss md:text-xl">{name}</span>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.15}>
                <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-moss" data-testid="insurers-note">
                    + 30 more insurers · All names belong to their respective owners
                </p>
            </Reveal>
        </div>
    </section>
);
